module.exports = __webpack_public_path__ + "static/media/topper_plan_bowl.27ffd4c5.jpg";